import React, { lazy } from "react";

const VersionPage = lazy(() => import("./VersionPage"));

const versionRoute = {
  path: "essentials.version",
  element: <VersionPage />,
  root: false,
  permission: "ui_view_version",
};

export default versionRoute;
